export const faqs = [
  {
    q: "黑料今日日报多久更新一次？",
    a: "正常情况下每天更新一期，编辑部会在 09:00 之前完成当日精选的整理与归档。遇到重大娱乐话题集中爆发时，会在当天追加一次内容更新，并在页脚标注更新时间。",
  },
  {
    q: "「每日更新栏目」是怎么划分的？",
    a: "目前设有顶流追踪、影视剧透、综艺风波、音乐圈事、时尚资源、带货直播、情感瓜田、幕后爆料共 8 个固定栏目。每条内容只归入最贴切的一个栏目，并用标签做二次索引。",
  },
  {
    q: "可以只订阅某一个栏目吗？",
    a: "可以。在订阅表单里勾选你关心的栏目即可，不勾选则默认接收全站精选。栏目可以随时调整，不需要重新注册，也不会影响已经订阅的记录。",
  },
  {
    q: "站点的信息主要从哪里来？",
    a: "全部来自公开传播的娱乐资讯与网络讨论。编辑部的工作是把分散的信息按时间线整理清楚，并标注来源与不确定性，不发布任何非公开的个人信息。",
  },
  {
    q: "如果我发现问题内容，要怎么反馈？",
    a: "可以发送邮件到 heyliao@example.com 说明具体条目与理由。我们会在核实后更正、补充说明或下线该条目，并在文末标注更新记录。",
  },
  {
    q: "内容里的说法可以直接当作事实吗？",
    a: "不建议。日报的定位是信息索引，很多条目在整理时仍处于讨论阶段。请以官方渠道的正式回应为准，把这里当作了解话题脉络的入口更合适。",
  },
  {
    q: "如何取消订阅？",
    a: "每封日报邮件的底部都有一键退订入口，点击即可停止接收。也可以来信说明邮箱地址，我们会在一个工作日内为你处理。",
  },
  {
    q: "在手机上浏览体验如何？",
    a: "站点采用响应式设计，手机、平板与电脑都能正常阅读。导航支持折叠展开，列表页支持栏目切换与关键词搜索，长文页面提供目录跳转方便定位。",
  },
];